module.exports = __webpack_public_path__ + "static/media/facebook.0c30840a.svg";